import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IsoCountryCode } from 'src/app/model/configuration';
import { OperationResult } from '@tb/auth';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthorizationProperties, AppSecurityInfo } from 'src/app/authentication/auth-info';
import { MiniStorageService } from './mini-storage.service';
import { TbAuthService } from '@tb/auth';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlMaker } from 'src/app/commons/url-maker';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProductCode } from 'src/app/model/industry';

@Injectable({
    providedIn: 'root',
})
export class ServiceUtilsService {
    authorizationStored: string;

    constructor(
        private miniStorage: MiniStorageService,
        public authService: TbAuthService,
        public router: Router,
        private http: HttpClient,
        private configurationService: ConfigurationService,
        private workflow: WorkFlowService
    ) {}

    CreateAuthorizationHeader(authorizationType: string): string {
        //qui non uso il loginservice se no si creano dipendenze circolari
        if (this.authService.isSessionStorage()) {
            this.authorizationStored = sessionStorage.getItem('auth-info');
        } else {
            this.authorizationStored = localStorage.getItem('auth-info');
        }

        if (this.authorizationStored !== null) {
            const authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);

            let authorizationHeader = '';

            if (authorizationType.toLowerCase() === 'jwt') {
                authorizationHeader = '{ "Type": "Jwt", "SecurityValue": "' + authorizationProperties.jwtEncoded + '"}';
            }

            if (authorizationType.toLowerCase() === 'app') {
                this.miniStorage.get('app-bag').subscribe((res) => {
                    if (res !== undefined) {
                        const aInfo: AppSecurityInfo = res;
                        authorizationHeader =
                            '{ "Type": "App", ' + '"AppId": "' + aInfo.AppId + '", "SecurityValue": "' + aInfo.SecurityValue + '"}';
                    } else {
                        alert('ServiceUtilsService component (CreateAuthorizationHeader: app-bag is undefined)');
                        this.router.navigateByUrl('/home');
                        return;
                    }
                });
            }

            return authorizationHeader;
        }

        return '';
    }

    getProductIDByProductCode(pc: string) {
        switch (pc) {
            case ProductCode.MAGOWEB:
                return 'MW';
            case ProductCode.MAGOCLD:
                return 'MC';
            default:
                return pc;
        }
    }

    public async getStoreParameterValue(paramName: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('param');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            authKey: environment.auth.authToken,
            paramName: paramName,
        };

        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }
    // public async getOnPremiseDiscount(): Promise<OperationResult> {
    //     const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('onpremisesdiscount');

    //     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     const jobj = {
    //         authKey: environment.auth.authToken,
    //     };
    //     return this.http
    //         .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
    //             headers: headers,
    //         })
    //         .toPromise();
    // }

    public downloadScriptFiles(versionFolder: string, accountName: string): Promise<any> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('script')
            .appendSegment(versionFolder)
            .appendSegment(accountName);

        return this.http
            .get(url.toString(), {
                responseType: 'arraybuffer',
            })
            .pipe(catchError((error: any) => throwError(error || 'server error (downloadFromRedis)')))
            .toPromise();
    }

    public deleteTmpScriptFiles(versionFolder: string, accountName: string): Promise<OperationResult> {
        const url = new UrlMaker()
            .appendBaseUrl(environment.settings.storeApiUrl)
            .appendSegment('script')
            .appendSegment('delete')
            .appendSegment(versionFolder)
            .appendSegment(accountName);

        return this.http
            .get<OperationResult>(url.toString())
            .pipe(catchError((error: any) => throwError(error || 'file not deleted')))
            .toPromise();
    }

    public async getAWSScriptFoldersList(): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(environment.settings.storeApiUrl).appendSegment('folders');

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            authKey: environment.auth.authToken,
        };
        return this.http
            .post<OperationResult>(url.toString(), JSON.stringify(jobj), {
                headers: headers,
            })
            .toPromise();
    }

    public async getCountryDescription(countryCode: string) {
        let culture = this.workflow.getLanguageForCms();
        let data: IsoCountryCode[] = await this.configurationService.getAllSupportedISOCountryCode(culture);
        if (data === null || data === undefined) {
            return countryCode;
        } else {
            let country: IsoCountryCode = data.find((x) => x.ISOCountryCode == countryCode);
            if (!country) return countryCode;
            else return country.Description;
        }
    }
}
